export default __webpack_public_path__ + "static/media/tms_v2.511e08d2.jpg";